import React, { useRef, useState } from "react";
import { Button, Grid, LinearProgress, Modal, Paper,Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  IconButton,
  Chip,
  TextField,
  InputAdornment,
  CircularProgress, } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Service from "../../../service";

import { DatePicker, Radio, Select, TimePicker } from 'antd';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import 'moment/locale/fr';
import frFR from 'antd/es/date-picker/locale/fr_FR';
import { AccountBalanceWallet, Add, Cancel, Check, Delete, DeleteOutline, Edit, PictureAsPdf, Search } from "@material-ui/icons";
import { Constant } from "../../../constant";
import Widget from "../../../components/Widget/Widget";

import useStyles from "../../dashboard/styles";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// import {num2} from '../../../chant/num2'
// import HTMLtoDOCX from "html-to-docx";
// import { saveAs } from "file-saver";

dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const format = 'HH:mm';
const list = 'LIST';
let ajout = "";
let tab = []
export default function NoterCandidat() {
  const [spinner, setSpinner] = useState(false);
  const [spinner2, setSpinner2] = useState(false);
  const [reponse, setReponse] = useState([]);
  const [serverSide, setServerSide] = useState(true);
  const [annee, setAnnee] = useState([]);
  const [programmation, setProgrammation] = useState([]);
  const [epreuve, setEpreuve] = useState([]);
  var [open, setOpen] = useState(false);
  var [page, setPage] = useState({page: 0, size: 50, totalElements: 0});
  const [recherche, setRecherche] = React.useState({
    annee: 0,
    idEvaluation: ""
  });
  const [value, setValue] = useState("");

  
  React.useEffect(() => {
    (()=>{
      // pdf(betiba, "betiba")
      bindAnnees()
    })();
  }, []);

  const onChange = (e) => {
    setValue(e.target.value);
  };

const GetEvaluations = async (page, size, year) => {
  Service.GetEvaluations(page, size, year).then(
    async (response) => {
      setProgrammation(response.data)
    }, error => {
      toast.error(error.response.data.error, {position: "top-center", autoClose: 10000,})
  })
}

    //Functions
    function bindAnnees (){
      Service.GetAnneeScolaire().then(anneesBinded => {
        let year = anneesBinded.data.content[anneesBinded.data.content.length -1].id;
          setRecherche({...recherche, annee: year})
          setAnnee(anneesBinded.data.content);
          GetEvaluations(-1, -1, year)
      });
    }

    const inti = (message) => {
      setSpinner2(false)
      toast.success(message, {position: "top-center", autoClose: 10000,})
      GetNoteAnonymats(page.page, page.size)
    }

  const enregistrer = () => {
      setSpinner2(true)
      let lists = reponse.filter((a)=> a.mark.trim() != "");
      let resultat = JSON.parse(JSON.stringify(lists).split("anonymous").join("candidateNumberAnonymity"));
      if(ajout === true) {
        Service.NoterCandidat(resultat).then(
          async (response) => {
            inti(response.data)
          }, error => {
            setSpinner2(false)
            toast.error(error.response.data.error, {position: "top-center", autoClose: 10000,})
          })
        } else {
        Service.ModifierNoteCandidat(resultat.filter((a)=> a.evaluationId !== undefined)).then(
          async (response) => {
            inti(response.data)
          }, error => {
            setSpinner2(false)
            toast.error(error.response.data.error, {position: "top-center", autoClose: 10000,})
        })
      }
  }

  const columns = [
      {
        name: "anonymous",
        label: "Anonymat",
        options: {
          filter: true,
          sort: true,
         }
      },
      {
        name: "mark",
        label: "Note",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <div>
              <TextField key={tableMeta.tableData[tableMeta.rowIndex].anonymous} style={{backgroundColor: 'white'}} type="number" 
              defaultValue={tableMeta.tableData[tableMeta.rowIndex].mark}
              onChange={(e)=>{
                tableMeta.tableData[tableMeta.rowIndex].mark = e.target.value;
                tableMeta.tableData[tableMeta.rowIndex].numberCorrection = recherche.numberCorrection;
                tableMeta.tableData[tableMeta.rowIndex].evaluationId = recherche.idEvaluation;
                }}
                size="small" fullWidth />
            </div>;
          }
         },
      },
    ];


const GetNoteAnonymats = async (page, size) => {
  setSpinner(true)
  if(value === true){
    // , type, recherche.numberCorrection, value
      Service.GetCandidatSansNote(page, size, recherche.idEvaluation, list, recherche.numberCorrection).then(
        async (response) => {
          ajout = true
          setSpinner(false)
          setPage({
            page: page,
            size: size,
            totalElements: response.data.totalElements
          })
          setReponse(response.data.content)
        }, error => {
          setSpinner(false);
          toast.error(error.response.data.error, {position: "top-center", autoClose: 10000,})
        })
    } else if(value === false) {
      Service.GetNoteAnonymats(page, size, recherche.idEvaluation, "LIST", recherche.numberCorrection, value).then(
        async (response) => {
          ajout = false
          setSpinner(false)
          setPage({
            page: page,
            size: size,
            totalElements: response.data.totalElements
          })
          setReponse(response.data.content)
        }, error => {
          setSpinner(false);
          toast.error(error.response.data.error, {position: "top-center", autoClose: 10000,})
      })

    }

}

  return (
    <>
    
      <ToastContainer />
      <PageTitle title="Gestion des notes avec anonymats" />
      <Grid container spacing={4}>
        <Grid item sm={6}>
          <Select
            placeholder="Evaluation"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%", zIndex: 1}}
              onChange={(e)=>setRecherche({...recherche, idEvaluation: e})}
              options=
              {
                programmation.length > 0 && programmation.map((element) => {
                  return { "value": element.id, "label": element.programmationExamination.examination.name + " (Etape: "+element.programmationExamination.examination.step+")" + " ("+element.programmationExamination.programmationCategoryProfession.competitionCategory.name+")" }
                })
              }
            />
        </Grid>
        <Grid item sm={3}>
            <Select
                placeholder="Nombre de correction"
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%", zIndex: 1}}
                onChange={(e)=>setRecherche({...recherche, numberCorrection: e})}
                options=
                {Constant.nbrCorrection}
              />
        </Grid>
        <Grid item sm={3}>
          <Radio.Group onChange={onChange} value={value}>
            <Radio value={true} style={{color: 'white'}}>Ajouter</Radio>
            <Radio value={false} style={{color: 'white'}}>Modifier</Radio>
          </Radio.Group>
        </Grid>
        <Grid item sm={2} style={{flexDirection: 'row'}}>
          <Button onClick={(e)=>GetNoteAnonymats(page.page, page.size)} variant="contained" startIcon={<Search />} style={{color: 'black', backgroundColor: 'white'}}>
              Afficher
          </Button>
        </Grid>
        <Grid item sm={3} style={{flexDirection: 'row'}}>
         {ajout !== "" &&
            <Button onClick={(e)=>enregistrer()} variant="contained" startIcon={<Search />} style={{color: 'white', backgroundColor: 'red'}}>
                {ajout === true ? "Enregistrer les notes" : "Appliquer les modifications"} &nbsp; {spinner2 && <CircularProgress size={20} style={{color: 'white'}}/>}
            </Button>
          }
        </Grid>
        <Grid item xs={12}>
          {spinner && <LinearProgress color={Constant.couleurSpinnerLine} />}
          <MUIDataTable
            title="Gestion des notes avec anonymats"
            data={reponse}
            columns={columns}
            options={{
              draggableColumns: { enabled: true },
              enableNestedDataAccess: '.',
              filterType: "multiselect",
              jumpToPage: true,
              serverSide: serverSide,
              rowsPerPageOptions:[50, 100, 500, 1000],
              rowsPerPage: page.size,
              count: page.totalElements,
              textLabels: Constant.textLabels,
              selectableRows: "none",
              setFilterChipProps: (colIdx, colName, data) => {
                return {
                  label: `${colName}: ${data}`,
                }
              },
              onTableChange(action, tableState) {
                if(action === "sort" || action === "filterChange" || action === "resetFilters" || action === "search") {
                  setServerSide(false)
                }
              },
              onChangePage(currentPage) {
                setServerSide(true)
                GetNoteAnonymats(currentPage, page.size)
              },
              onChangeRowsPerPage(numberOfRows) {
                setServerSide(true)
                GetNoteAnonymats(page.page, numberOfRows)
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}
